import React, { useState, useEffect, Fragment } from "react"
import "./what-can-i-win.scss"
import { useStaticQuery, graphql } from "gatsby"
import Loader from "react-loader-spinner"
import { siteUrl } from "../../../shared/utils/siteUrl"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import FormatNumber from "../../../shared/utils/formatNumber"

import MyPointsService from "../../../shared/services/my-points-service"
import EnvironmentalCard from "../../atoms/environmental-card/environmental-card"
import { getTextWhatCanIWin } from "../../../utils/getPointMessages"
import { createListPrizePayload } from "../../../shared/utils/payloadDatalayer"
import { pushGtagEvent, pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"

const WhatCanIWin = props => {
  const { mobile } = props
  const resultQuery = useStaticQuery(
    graphql`
      query ACTIVITY_QUERY {
        allContentfulNolHomeTercerNivel(
          filter: { slug: { in: ["que-puedo-ganar-1","que-puedo-ganar-1/"] } }
        ) {
          nodes {
            node_locale
            concursos {
              node_locale
              titulo
              slug
              redireccionParaParticipar
              imagenMiniatura {
                fluid {
                  base64
                }
                file {
                  url
                }
                description
              }
            }
            premiosFisicos {
              imagenDelPremioPrevisualizacion {
                fluid {
                  base64
                }
                description
                file {
                  url
                }
              }
              codigoDePremio
              nombreDelBono
              numeroDePuntos
              slug
              descripcionDelBono {
                json
              }
              premioActivo
              etiquetaIndisponibilidad
            }
            premiosDigitales {
              imagenDelPremioPrevisualizacion {
                fluid {
                  base64
                }
                description
                file {
                  url
                }
              }
              codigoDePremio
              nombreDelBono
              numeroDePuntos
              slug
              descripcionDelBono {
                json
              }
              premioActivo
              etiquetaIndisponibilidad
            }
          }
        }

        allContentfulNolMisPuntosPremios(
          filter: { esPremioDescargable: { eq: true } }
        ) {
          nodes {
            node_locale
            imagenDelPremioPrevisualizacion {
              fluid {
                base64
              }
              description
              file {
                fileName
                url
              }
            }
            imagenDelPremioCompleta {
              description
              file {
                fileName
                url
              }
            }
            codigoDePremio
            nombreDelBono
            numeroDePuntos
            slug
            descripcionDelBono {
              json
            }
            premioActivo
            esPremioDescargable
          }
        }

        allContentfulNolPaises(filter: { node_locale: { eq: "es-CO" } }) {
          nodes {
            tienePremiosVirtuales
            tieneActividades
            tieneDescargables
            codigoIcu
          }
        }
      }
    `
  )

  const {
    premiosFisicos: infoPhysicalPrizes,
    premiosDigitales: infoVirtualAwards,
    concursos: infoContests,
  } = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(
    e => e.node_locale === process.env.LOCALE
    )[0]
  const {
    tienePremiosVirtuales: haveVirtualAwards,
    tieneActividades: haveActivities,
    tieneDescargables: haveDownloadables
  } = resultQuery.allContentfulNolPaises.nodes.filter(
    e => e.codigoIcu === process.env.LOCALE
    )[0]

  const infoDownloadables = resultQuery.allContentfulNolMisPuntosPremios.nodes.filter(
    e => e.node_locale === process.env.LOCALE
  )

  const [prizesSoldOut, setPrizesSoldOut] = useState([])
  const [loaded, setLoaded] = useState(true)
  const [pageLoad, setPageLoad] = useState(false)
  const [isLogin, setisLogin] = useState(false)
  const homeLink = siteUrl
  const [whatCanI, setwhatCanI] = useState(false)
  const [downloading, setDownloading] = useState(false)

  useEffect(() => {
    setPageLoad(true)
    setisLogin(localStorage.getItem("TOKEN_INFO"))
    setLoaded(false)

    MyPointsService.getPrices()
      .then(res => {
        if (res.status === 400 || res.status === 404) {
          // console.log("status 400", res);
        } else if (res.status === 200) {
          setLoaded(false)
          setPrizesSoldOut(res.data)
        }
      })
      .catch(err => console.log(err))
  }, [])

  if (pageLoad && !whatCanI) {
    const pixelToScroll = mobile ? 700 : 510
    
    setwhatCanI(true)
    setTimeout(() => {
      window.scrollTo(0, pixelToScroll)
    }, 200)
  }

  const NextArrow = props => {
    const { onClick } = props
    return <span className="f-slider-awards-videos-next" onClick={onClick} />
  }

  const NextArrowMobile = props => {
    const { onClick } = props
    return <span className="f-slider-home-estore-next" onClick={onClick} />
  }
  const PrevArrowMobile = props => {
    const { onClick } = props
    return <span className="f-slider-home-estore-prev" onClick={onClick} />
  }

  const settings = {
    infinite: true,
    slidesToShow: mobile
      ? 1
      : infoPhysicalPrizes.length > 3
        ? 3
        : infoPhysicalPrizes.length < 3
          ? infoPhysicalPrizes.length
          : infoDownloadables.length < 3
            ? infoDownloadables.length
            : 3,
    slidesToScroll: 1,
    centerMode: mobile ? true : false,
    nextArrow: <NextArrow />,
  }

  const settingsVirtual = {
    infinite: true,
    slidesToShow: mobile
      ? 1
      : infoVirtualAwards.length < 3
        ? infoVirtualAwards.length
        : 3,
    slidesToScroll: 1,
    centerMode: mobile ? true : false,
    nextArrow: <NextArrow />,
  }

  const settingsActivities = {
    infinite: true,
    slidesToShow: infoContests
      ? mobile
        ? 1
        : infoContests.length < 3
          ? infoContests.length
          : 3
      : 1,
    slidesToScroll: 1,
    centerMode: mobile ? true : false,
    nextArrow: <NextArrow />,
  }

  const settingsMobile = {
    dots: true,
    infinite: true,
    slidesToShow: mobile ? 1 : 2,
    slidesToScroll: 1,
    centerMode: true,
    focusOnSelect: true,
    initialSlide: 0,
    nextArrow: <NextArrowMobile />,
    prevArrow: <PrevArrowMobile />,
  }

  const ComingSoon = ({ etiquetaIndisponibilidad }) => {
    return (
      <div className="f-soldoutflag">
        <p className="f-soldout">
          {etiquetaIndisponibilidad || "Próximamente"}
        </p>
      </div>
    )
  }
  const handleDownloadImg = (url, fileName) => {
    try {
      setDownloading(true)
      fetch(url)
        .then(res => res.blob()) // Gets the response and returns it as a blob
        .then(blob => {
          const fileURL = window.URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = fileURL
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
    } finally {
      setDownloading(false)
    }
  }

  const SoldOutFlag = () => {
    return (
      <div className="f-soldoutflag">
        <p className="f-soldout">Agotado</p>
      </div>
    )
  }

  const awardsItems = (data, category = null) => {
    return data.map((info, index) => {
      const isDownloadable = !!info.esPremioDescargable

      if (!info.premioActivo && isDownloadable) {
        return <div key={index} />
      }

      return (
        <div key={index} className="f-card-container">
          <a
            className={
              "f-carousel-awards-item f-carousel-videos-pos-" +
              index +
              (downloading ? " f-loading-pointer" : "")
            }
            href={
              !info.premioActivo || isDownloadable
                ? "#"
                : "/mis-puntos/que-puedo-ganar/" + info.slug
            }
            // href={'/mis-puntos/que-puedo-ganar/' + info.slug}
            onClick={e => {
              if (isDownloadable && !downloading) {
                e.preventDefault()
                handleDownloadImg(
                  info.imagenDelPremioCompleta.file.url,
                  info.imagenDelPremioCompleta.file.fileName
                )
              }

              if (category) {
                selectPrizeDatalayer(category, info)
              }
            }}
          >
            <div className="f-awards-img-container">
              <img
                className="f-carousel-videos-imagen"
                alt={info.imagenDelPremioPrevisualizacion.description}
                src={
                  pageLoad
                    ? info.imagenDelPremioPrevisualizacion.file.url
                    : info.imagenDelPremioPrevisualizacion.fluid.base64
                }
              />
            </div>

            <div className="f-carousel-videos-description">
              <>
                <p className="f-title f-flex">{info.nombreDelBono}</p>
                {info.descripcionDelBono && (
                  <p className="f-description f-flex">
                    {info.descripcionDelBono.json.content[0].content[0].value}
                  </p>
                )}
              </>
              <p className="f-points f-flex">
                {!isDownloadable ? (
                  <>
                    {FormatNumber(info.numeroDePuntos)}{" "}
                    {!info.premioActivo ? "" : "puntos"}
                  </>
                ) : (
                  "Descargar"
                )}
              </p>
            </div>
          </a>
          {loaded ? (
            <div className="f-card-mask">
              <Loader type="TailSpin" color="#FF409B" height={50} width={50} />
            </div>
          ) : (
            <>
              {!info.premioActivo ? (
                <div className="f-card-mask">
                  <ComingSoon
                    etiquetaIndisponibilidad={info.etiquetaIndisponibilidad}
                  />
                </div>
              ) : (
                <>
                  {prizesSoldOut.map((item, index) => {
                    return (
                      <div key={index}>
                        {info.codigoDePremio === item.prizeId &&
                          item.quantity === 0 && (
                            <div className="f-card-mask">
                              <SoldOutFlag />{" "}
                            </div>
                          )}
                      </div>
                    )
                  })}
                </>
              )}
            </>
          )}
        </div>
      )
    })
  }

  // prizesSoldOut && prizesSoldOut.find(el => el.prizeId === info.codigoDePremio).quantity === 0 ||
  const awardsItemsMobile = (data, category = null) => {
    return data.map((info, index) => {
      const isDownloadable = !!info.esPremioDescargable

      if (!info.premioActivo && isDownloadable) {
        return <div key={index} />
      }

      return (
        <a
          className={`f-carousel-estore-pos-${index} ${!info.premioActivo ? " f-disable" : ""}`}
          key={index}
          href={
            isDownloadable ? "#" : "/mis-puntos/que-puedo-ganar/" + info.slug
          }
          onClick={e => {
            if (isDownloadable && !downloading) {
              e.preventDefault()
              handleDownloadImg(
                info.imagenDelPremioPrevisualizacion.file.url,
                info.imagenDelPremioPrevisualizacion.file.fileName
              )
            }
            
            if (category) {
              selectPrizeDatalayer(category, info)
            }
          }}
        >
          <div className="f-section-estore-item">
            <img
              className="f-section-estore-item-img"
              src={info.imagenDelPremioPrevisualizacion.file.url}
              alt={info.imagenDelPremioPrevisualizacion.description}
            />
            <label className="f-estore-description">{info.nombreDelBono}</label>
            {info.descripcionDelBono && (
              <p className="f-description-mobile">
                {info.descripcionDelBono.json.content[0].content[0].value}
              </p>
            )}
            {isDownloadable ? (
              <span className="f-estore-points">Descargar</span>
            ) : (
              <span className="f-estore-points">
                {FormatNumber(info.numeroDePuntos)} puntos
              </span>
            )}
            {loaded ? (
              <div className="f-card-mask-mobile">
                <Loader
                  type="TailSpin"
                  color="#FF409B"
                  height={50}
                  width={50}
                />
              </div>
            ) : (
              <>
                {!info.premioActivo ? (
                  <div className="f-card-mask-mobile">
                   <ComingSoon
                    etiquetaIndisponibilidad={info.etiquetaIndisponibilidad}
                  />{" "}
                  </div>
                ) : (
                  <>
                    {prizesSoldOut.map((item, index) => {
                      return (
                        <Fragment key={index}>
                          {info.codigoDePremio === item.prizeId &&
                            item.quantity === 0 && (
                              <div className="f-card-mask-mobile">
                                <SoldOutFlag />{" "}
                              </div>
                            )}
                        </Fragment>
                      )
                    })}
                  </>
                )}
              </>
            )}
          </div>
        </a>
      )
    })
  }

  const listItems = infoContests?.map((info, index) => {
      return (
        <a
          className={
            "f-carousel-awards-item-activity f-carousel-videos-pos-" + index
          }
          key={index}
          href={
            homeLink +
            (info.titulo !== "contenido-oculto" ? "" : "") +
            info.redireccionParaParticipar
          }
          rel="noreferrer noopener"
          target="_blanck"
        >
          <div className="f-img-container-activity">
            <img
              className="f-carousel-videos-imagen-activity"
              alt={info.imagenMiniatura[0].fluid.description}
              src={
                pageLoad
                  ? info.imagenMiniatura[0].file.url
                  : info.imagenMiniatura[0].fluid.base64
              }
            />
          </div>
          {info.titulo !== "contenido-oculto" && (
            <div className="f-carousel-videos-description-activity">
              <p className="f-title-activity f-flex">{info.titulo}</p>
            </div>
          )}
        </a>
      )
    }) || null

  const userInfoEncrypt= encryptUserInfo()
  const selectPrizeDatalayer = (category, prize) => {
    let items = createListPrizePayload([prize], {
      item_list_name: category,
      item_category: category,
      item_list_id: "PF_2345",
    })
    delete items[0].price;
    pushGtagEvent({
      event: "select_item",
      params: {
        points: prize.numeroDePuntos || 0,
        item_list_name: category,
        item_list_id: "PF_2345",
        redemption: 'Si',
        items,
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      },
    })
    pushDataLayerEvent({
      event: "product_click",
      single_item_id: items[0].item_id,
      single_item_name: items[0].item_name,
      link_text: items[0].item_name,
      link_url: window.location.host +  "/mis-puntos/que-puedo-ganar/" + prize.slug
    })
  }
  
  const pushPrizesDataLayer = (category, listPrizes) => {
    const itemsPayload = createListPrizePayload(listPrizes, {
      item_list_name: category,
      item_category: category,
      item_list_id: "PF_2345",
    })
    itemsPayload.forEach(premio => premio.price=0)
    pushGtagEvent({
      event: "view_item_list",
      params: {
        items: itemsPayload,
        item_list_name: category,
        item_list_id: "PF_2345",
        redemption: "Si",
        user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
        log_status: userInfoEncrypt.log_status,
      },
    })
  }

  useEffect(() => {
    if (infoPhysicalPrizes) pushPrizesDataLayer("Premios Fisicos", infoPhysicalPrizes)
    if (infoVirtualAwards) pushPrizesDataLayer("Premios Virtuales", infoVirtualAwards)
  }, [])

  return (
    <div className="f-whatcaniwin">
      {!isLogin && (
        <>
          {!mobile && (
            <span className="f-circle">
              <span className="f-circle-child" />
            </span>
          )}
          <span className="f-curve-effect-whatcaniwin" />
        </>
      )}

      <div
        className={
          "f-whatcaniwin-container " + (isLogin ? "f-back-container-login" : "")
        }
      >
        <div className="f-whatcaniwin-container-info">
          <h2 className="f-whatcaniwin-title">¿Qué puedo ganar?</h2>
          <p className="f-whatcaniwin-desc">
            {getTextWhatCanIWin(process.env.LOCALE)}
          </p>
        </div>
      </div>
      {process.env.LOCALE === "es-CL" && haveActivities && infoContests && (
          <>
            <div
              className={
                "f-SectionAwardsContent f-SectionActivityContent--cl " +
                (isLogin ? "f-back-login" : "f-back-noLogin")
              }
            >
              <div className="f-awards-info">
                <h3 className="f-award-title">Actividades</h3>
              </div>
              <Slider {...settingsActivities} className="f-carousel-awards">
                {listItems}
              </Slider>
            </div>
          </>
        )}

      {process.env.LOCALE !== "es-PR" && (
        <div
          className={
            "f-SectionAwardsContent " +
            (isLogin ? "f-back-login" : "f-back-noLogin")
          }
        >
          <div className="f-awards-info">
            <h3 className="f-award-title">Premios físicos</h3>
          </div>
          {mobile ? (
            <>
              {infoPhysicalPrizes ? (
                <Slider
                  {...settingsMobile}
                  className="f-carousel-awards-mobile"
                >
                  {awardsItemsMobile(infoPhysicalPrizes, "Premios Fisicos")}
                </Slider>
              ) : (
                <div className="f-section-estore-error">
                  <p>No hay premios por el momento</p>
                </div>
              )}
            </>
          ) : (
            <Slider {...settings} className="f-carousel-awards">
              {awardsItems(infoPhysicalPrizes, "Premios Fisicos")}
            </Slider>
          )}
        </div>
      )}

      {process.env.LOCALE !== "es-PR" && (
        <div
          className={
            "f-SectionAwardsContent " +
            (isLogin ? "f-back-login" : "f-back-noLogin")
          }
        >
          {haveDownloadables && (
            <>
              <div className="f-awards-info">
                <h3 className="f-award-title">Descargables</h3>
              </div>
              {mobile ? (
                <>
                  {infoDownloadables ? (
                    <Slider
                      {...settingsMobile}
                      className="f-carousel-awards-mobile"
                    >
                      {awardsItemsMobile(infoDownloadables)}
                    </Slider>
                  ) : (
                    <div className="f-section-estore-error">
                      <p>No hay premios por el momento</p>
                    </div>
                  )}
                </>
              ) : (
                <Slider {...settings} className="f-carousel-awards">
                  {awardsItems(infoDownloadables)}
                </Slider>
              )}
            </>
          )}
        </div>
      )}

      <div
        className={`section--last f-SectionAwardsContent ${process.env.LOCALE === "es-CL" ? "f-SectionAwardsContent--cl" : ""
          } ${isLogin ? "f-back-login" : "f-back-noLogin"}`}
      >
        {haveVirtualAwards ? (
          <>
            <div className="f-awards-info">
              <h3 className="f-award-title">Premios virtuales</h3>
            </div>

            {mobile ? (
              <>
                {infoVirtualAwards ? (
                  <Slider
                    {...settingsMobile}
                    className="f-carousel-awards-mobile"
                  >
                    {awardsItemsMobile(infoVirtualAwards, "Premios Virtuales")}
                  </Slider>
                ) : (
                  <div className="f-section-estore-error">
                    <p>No hay premios por el momento</p>
                  </div>
                )}
              </>
            ) : (
              <Slider {...settingsVirtual} className="f-carousel-awards">
                {awardsItems(infoVirtualAwards, "Premios Virtuales")}
              </Slider>
            )}
          </>
        ) : null}
      </div>

      {process.env.LOCALE !== "es-CL" && haveActivities && infoContests && (
          <>
            <div
              className={
                "f-SectionAwardsContent f-SectionActivityContent " +
                (isLogin ? "f-back-login" : "f-back-noLogin")
              }
            >
              <div className="f-awards-info">
                <h3 className="f-award-title">Actividades</h3>
              </div>
              <Slider {...settingsActivities} className="f-carousel-awards">
                {listItems}
              </Slider>
            </div>
          </>
        )
      }

      {mobile && (
        <div className="f-footer-whataniwin">
          <div
            className={
              "f-release-curve " + (isLogin ? " f-login-curve-back" : "")
            }
          ></div>
          <EnvironmentalCard />
        </div>
      )}
    </div>
  )
}

export default WhatCanIWin
